import { __extends, __read } from "tslib";
import { CookieStorage } from './cookie';
var UTMCookie = /** @class */ (function (_super) {
    __extends(UTMCookie, _super);
    function UTMCookie() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UTMCookie.prototype.get = function (key) {
        try {
            var value = this.findByKey(key);
            if (!value) {
                return undefined;
            }
            var entries = value.split('.').splice(-1)[0].split('|');
            return entries.reduce(function (acc, curr) {
                var _a = __read(curr.split('=', 2), 2), key = _a[0], _b = _a[1], value = _b === void 0 ? '' : _b;
                if (!value) {
                    return acc;
                }
                acc[key] = decodeURIComponent(value);
                return acc;
            }, {});
        }
        catch (_a) {
            return undefined;
        }
    };
    UTMCookie.prototype.set = function () {
        return undefined;
    };
    return UTMCookie;
}(CookieStorage));
export { UTMCookie };
//# sourceMappingURL=utm-cookie.js.map